export function officeLight() {
    var lightOpacity = 0;
    $('.light').on('mouseover', function () {
        $('.light').css('opacity', (lightOpacity = Number(! lightOpacity)));
    });
}


// WEBPACK FOOTER //
// ./modules/officeLight.js